import { Card } from 'antd';
import React, { FC, memo } from 'react';
import { AppLogo } from 'app/appState';
import { LangSwitcher } from 'features/LangSwitcher';
import { ForgotPasswordSteps } from 'widgets/AuthForm';

export const ForgotPasswordPage: FC = memo(() => {
  return (
    <div className="h-screen flex flex-col justify-center items-center bg-accentLight">
      <Card
        className="w-[370px] pt-[24px] tablet:w-[450px]"
        title={
          <div className="flex items-center p-3 justify-center">
            <AppLogo width={180} height="100%" />
            <div className="absolute top-0 right-0">
              <LangSwitcher />
            </div>
          </div>
        }
      >
        <ForgotPasswordSteps />
      </Card>
    </div>
  );
});
